export default __webpack_public_path__ + "static/media/nextTopic_bg.a0cdeb3d.png";